<section>

    <div class="page page-dashboard">

        <div class="pageheader">

            <h2>Super Admin</h2>

            <div class="page-bar">


            </div>

        </div>

        <!-- page content -->
        <div class="pagecontent">

            <!-- row -->
            <div class="row">

                <div class="col-md-12">
                    <div class="tile tile-simple">

                        <!-- tile body -->
                        <div class="tile-body">
                            <div role="tabpanel">

                                <div class="tab-content">

                                    <div role="tabpanel" class="tab-pane active" id="dashboard">
                                        <!-- cards row -->
                                        <div class="row cmn-height">

                                            <!-- Total Active Users -->
                                            <div class="card-container col-lg-4 col-sm-6 col-sm-12">
                                                <div class="card">

                                                    <div class="front bg-greensea">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="fa fa-group fa-5x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    Total Active Users</p>
                                                                <span><span
                                                                        class="no-strong">{{total_users}}</span></span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-greensea">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.Deadline_List]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Total Users Logged -->
                                            <div class="card-container col-lg-4 col-sm-6 col-sm-12">
                                                <div class="card">
                                                    <div class="front bg-lightred">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="fa fa-user fa-5x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">Today Users Logged
                                                                    in</p>
                                                                <span><span class="no-strong">{{ total_login
                                                                        }}</span></span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>

                                                    <div class="back bg-lightred">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.Servicing_List]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Renewal Users -->
                                            <div class="card-container col-lg-4 col-sm-6 col-sm-12">
                                                <div class="card">
                                                    <div class="front bg-blue">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="fa fa-star fa-5x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">Total need to
                                                                    Renewal Users this month</p>
                                                                <span><span class="no-strong">{{ renew }}</span></span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-blue">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.EMPLOYEE_LIST]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="row cmn-height" style="margin-top: 15px;">

                                            <!-- Recently added users -->
                                            <div class="col-sm-6">
                                                <div class="panel panel-default">
                                                    <div class="panel-heading">
                                                        Recent Added Users
                                                    </div>
                                                    <div class="panel-body">
                                                        <div class="dashboard-box2">


                                                            <table class="table table-striped table-hover">
                                                                <thead>
                                                                    <tr>
                                                                        <th> Company Name</th>
                                                                        <th>Activation date</th>
                                                                        <th>Renewal date</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr *ngFor="let ruser of recent_user let i = index">
                                                                        <td><a [routerLink]="['/super/'+AppFrontRoutes.SUPER_USER_DETAILS+'/'+ruser.user_no]">
                                                                                {{ ruser.company }}</a>
                                                                        </td>
                                                                        <td>{{ ruser.login_now | date:'yyyy:MM:dd' }}
                                                                        </td>
                                                                        <td>{{ruser.exp_date}}</td>
                                                                    </tr>


                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- No of installation graph -->
                                            <div class="col-sm-6">
                                                <apx-chart [series]="installChartOptions.series"
                                                    [chart]="installChartOptions.chart"
                                                    [dataLabels]="installChartOptions.dataLabels"
                                                    [plotOptions]="installChartOptions.plotOptions"
                                                    [yaxis]="installChartOptions.yaxis"
                                                    [xaxis]="installChartOptions.xaxis"
                                                    [legend]="installChartOptions.legend"
                                                    [colors]="installChartOptions.colors"
                                                    [grid]="installChartOptions.grid"></apx-chart>

                                            </div>

                                            <!-- Coming Renewal list Users -->
                                            <div class="col-sm-6">
                                                <div class="panel panel-default">
                                                    <div class="panel-heading">

                                                        Coming Renewal list Users </div>
                                                    <div class="panel-body">
                                                        <table class="table table-striped table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th> Company Name</th>
                                                                    <th>Activation date</th>
                                                                    <th>Renewal date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr style="color:red;"
                                                                    *ngFor="let euser of exp_user let i = index">
                                                                    <td><a [routerLink]="['/super/'+AppFrontRoutes.SUPER_USER_DETAILS+'/'+euser.user_no]">
                                                                            {{ euser.company }}</a>
                                                                    </td>
                                                                    <td>{{ euser.login_now | date:'yyyy:MM:dd' }}</td>
                                                                    <td>{{euser.exp_date}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Value graph -->
                                            <div class="col-sm-6">
                                                <apx-chart [series]="valueChartOptions.series"
                                                    [chart]="valueChartOptions.chart"
                                                    [dataLabels]="valueChartOptions.dataLabels"
                                                    [plotOptions]="valueChartOptions.plotOptions"
                                                    [yaxis]="valueChartOptions.yaxis" [xaxis]="valueChartOptions.xaxis"
                                                    [legend]="valueChartOptions.legend"
                                                    [colors]="valueChartOptions.colors" [grid]="valueChartOptions.grid">
                                                </apx-chart>
                                            </div>


                                            <!-- Value graph -->
                                            <div class="col-sm-12">
                                                <div style="text-align: -webkit-center;" *ngIf="pieChartOptions">
                                                    <apx-chart [series]="pieChartOptions.series"
                                                        [chart]="pieChartOptions.chart"
                                                        [labels]="pieChartOptions.labels"
                                                        [responsive]="pieChartOptions.responsive"></apx-chart>
                                                </div>
                                            </div>

                                        </div>


                                        <!-- /row -->


                                    </div>




                                </div>



                            </div>




                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>


</section>